import { MODULES } from "shared/config";

export const getTableColumns = (moduleName) => {
  const defaultColumns = [
    { label: "ID", accessor: "id", sortable: true },
    { label: "Card Number", accessor: "card_number", sortable: true },
    {
      label: "Card Holder",
      accessor: "card_holder_full_name",
      sortable: true,
    },
    {
      label: "Card Holder email",
      accessor: "card_holder_email",
      sortable: true,
    },
    {
      label: "Responsible person's email",
      accessor: "responsible_person_email",
      sortable: true,
    },
  ];

  let result;
  if (moduleName === MODULES.CORPORATE_CARDS) {
    result = {
      columns: [
        ...defaultColumns,
        {
          label: "Card holder name",
          accessor: "card_holder_name",
          sortable: true,
        },
      ],
      paginated: true,
      filtered: true,
    };
  } else {
    result = {
      columns: [
        ...defaultColumns,
        {
          label: "Supervisor",
          accessor: "supervisor_email",
          sortable: true,
        },
      ],
      paginated: true,
      filtered: true,
    };
  }

  result.columns.push({
    label: "Actions",
    accessor: "actions",
    sortable: false,
  });

  return result;
};
